import GeneralTracker from '../GeneralTracker';


export default class DomainTracker extends GeneralTracker {
  CAPTURE_NAME = 'session:domain';
  DATALAYER = true;
  VERSION = '1';

  constructor() {
    super();

    if (!window.dataLayer) {
      window.dataLayer = [];
    }
  }

  setHandlers() {
    const service = this.getService();
    service.on('domain', this.onDomainInfo);
  }

  onDomainInfo = () => {
    const { hostname } = window.location;
    this.track({
      Domain: hostname.substr(hostname.indexOf('.')),
      Subdomain: hostname,
      Responsive: 'true',
    });
  };
}
